import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import dataProvider from './dataProvider';
import japaneseLanguage from './language/ja';

import authProvider from './auth/authProvider';
import { MyLayout } from './components/layout/MyLayout';

import Dashboard from './pages/Dashboard';
import ProfileEdit from './pages/profile/ProfileEdit';
import user from './resources/user';
import seedling from './resources/Seedling';
import aggregate from './resources/aggregate';

const systemName = japaneseLanguage.system.name;
const i18nProvider = polyglotI18nProvider(() => japaneseLanguage, 'ja');

const App = () => (
	<Admin i18nProvider={i18nProvider} authProvider={authProvider} dataProvider={dataProvider} title={systemName} layout={MyLayout} dashboard={Dashboard}>
		<Resource name="user" {...user} />
		<Resource name="aggregate" {...aggregate} />
		<Resource name="seedling" {...seedling} />
		<CustomRoutes>
			<Route path="/profile" element={<ProfileEdit />} />
		</CustomRoutes>
	</Admin>
);

export default App;